const LOGIN_SESSION_KEY = 'Skinny-logged-in';
const CUSTOMER_INFO_KEY = 'Skinny-customer-info';
const CUSTOMER_PLANS_KEY = 'Skinny-customer-plans';

const LoginSessionHandler = {
  logIn: () => window.sessionStorage.setItem(LOGIN_SESSION_KEY, true),
  clear: () => {
    // eslint-disable-next-line no-console
    console.log('Called: LoginSessionHandler.clear()');
    window.sessionStorage.clear();
  },
  isLoggedIn: () => window.sessionStorage.getItem(LOGIN_SESSION_KEY) === 'true',
  getCustomerInfo: () => JSON.parse(window.sessionStorage.getItem(CUSTOMER_INFO_KEY)),
  setCustomerInfo: info => window.sessionStorage.setItem(CUSTOMER_INFO_KEY, JSON.stringify(info)),
  getAvailablePlans: () => JSON.parse(window.sessionStorage.getItem(CUSTOMER_PLANS_KEY)),
  setAvailablePlans: info => window.sessionStorage.setItem(CUSTOMER_PLANS_KEY, JSON.stringify(info))
};

export default LoginSessionHandler;



/** WEBPACK FOOTER **
 ** ./src/common/LoginSessionHandler.js
 **/